import { Controller } from "@hotwired/stimulus"

// « Encaisser » for one year of one fee (cash desk overhaul, lot 4): an
// amount received is spread from the oldest instalment to the latest, as the
// server's Allocation does; each line may be changed, never above what is
// left on it, and the total never above what is left on the year. The server
// checks it all again.
export default class extends Controller {
  static targets = ["amount", "line", "total", "capped", "submit"]
  static values = { currency: { type: String, default: "F CFA" } }

  connect() {
    this.refresh()
  }

  // The amount received: spread over the lines, oldest first.
  spread() {
    let left = Math.min(this.parse(this.amountTarget.value), this.cap)
    this.lineTargets.forEach((line) => {
      const take = Math.min(left, this.max(line))
      line.value = take > 0 ? take : ""
      left -= take
    })
    this.capTyped(this.parse(this.amountTarget.value) > this.cap)
    this.refresh()
  }

  // One line changed by hand: kept under what is left on it, the amount follows.
  lineChanged(event) {
    const line = event.target
    const typed = this.parse(line.value)
    if (typed > this.max(line)) line.value = this.max(line)
    this.amountTarget.value = this.total || ""
    this.capTyped(typed > this.max(line))
    this.refresh()
  }

  refresh() {
    const total = this.total
    if (this.hasTotalTarget) this.totalTarget.textContent = this.money(total)
    this.submitTargets.forEach((button) => { button.disabled = total <= 0 })
  }

  capTyped(capped) {
    if (this.hasCappedTarget) this.cappedTarget.hidden = !capped
  }

  get total() {
    return this.lineTargets.reduce((sum, line) => sum + this.parse(line.value), 0)
  }

  get cap() {
    return this.lineTargets.reduce((sum, line) => sum + this.max(line), 0)
  }

  max(line) {
    return parseInt(line.dataset.max, 10) || 0
  }

  // Whole francs, typed with or without spaces.
  parse(value) {
    return parseInt(String(value || "").replace(/\s/g, ""), 10) || 0
  }

  money(amount) {
    return `${amount.toLocaleString("fr-FR").replace(/ /g, " ")} ${this.currencyValue}`
  }
}
